export class KolumnaEwidencjiFiltrowanie {
    kolumna: string;
    wartoscSzukaj: string;
}